import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@/contexts/use-auth'

/**
 * Route guard guest-only képernyőkre (DEC-FE-006 / DEC-FE-013) — az admin
 * login-formot már bejelentkezett admin-eknek nem mutatjuk.
 */
export function RequireUnauth() {
  const { authUser } = useAuth()

  if (authUser) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
